'use strict';

(function () {
    'use strict';

    angular.module('zp').constant('config', { "zpAPI": { "HOST": "https://api.ludikamen.co.rs", "defaultRoutes": { "VENUES": "/db/venues", "BANDS": "/bands", "VENDORS": "/vendors", "USERS": "/user", "CATEGORIES": "/categories", "POSTS": "/posts" }, "customRoutes": { "PABOVI": "/pabovi", "PIVARE": "/pivare", "PIVA": "/piva" } }, "httpMethods": { "GET": "GET", "POST": "POST", "PUT": "PUT", "DELETE": "DELETE" }, "useGoogleAutocomplete": false });
})();